(function () {
  var AUTO_SCROLL_MS = 4500;

  function initSection(root) {
    if (!root || root.dataset.sbvInit === 'true') return;
    root.dataset.sbvInit = 'true';

    var track = root.querySelector('[data-shop-by-video-track]');
    if (!track) return;

    var cards = Array.from(root.querySelectorAll('.shop-by-video__card'));
    var autoTimer = null;
    var userPausedScroll = false;
    var sectionInView = false;
    var videosActivated = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getVideo(card) {
      return card.querySelector('video');
    }

    function prepareVideo(video) {
      if (!video || video.dataset.sbvReady === 'true') return;
      video.dataset.sbvReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');
      video.removeAttribute('autoplay');
      video.loop = true;
      video.preload = 'none';

      if (video.dataset.src && !video.getAttribute('src')) {
        video.setAttribute('src', video.dataset.src);
        video.removeAttribute('data-src');
      }

      /* Shopify video_tag sometimes embeds <source> — keep those, just don't autoplay */
      video.pause();
      try {
        video.currentTime = 0;
      } catch (err) {}
    }

    function loadVideoSources(video) {
      if (!video || video.dataset.sbvLoaded === 'true') return;
      video.dataset.sbvLoaded = 'true';

      if (video.dataset.src && !video.getAttribute('src')) {
        video.setAttribute('src', video.dataset.src);
        video.removeAttribute('data-src');
      }

      video.preload = 'metadata';
      try {
        video.load();
      } catch (err) {}
    }

    function playVideo(video) {
      if (!video || reduceMotion) return;
      loadVideoSources(video);
      video.muted = true;
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.catch(function () {});
      }
    }

    function pauseVideo(video) {
      if (!video) return;
      if (!video.paused) video.pause();
    }

    function pauseAllVideos() {
      cards.forEach(function (card) {
        pauseVideo(getVideo(card));
      });
    }

    function playVisibleVideos() {
      if (!sectionInView || reduceMotion) {
        pauseAllVideos();
        return;
      }

      cards.forEach(function (card) {
        var video = getVideo(card);
        if (!video) return;

        var rect = card.getBoundingClientRect();
        var trackRect = track.getBoundingClientRect();
        var visible =
          rect.right > trackRect.left + 20 &&
          rect.left < trackRect.right - 20 &&
          rect.bottom > 0 &&
          rect.top < (window.innerHeight || document.documentElement.clientHeight);

        if (visible) {
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    }

    function activateVideosOnce() {
      if (videosActivated) return;
      videosActivated = true;
      cards.forEach(function (card) {
        var video = getVideo(card);
        if (video) {
          prepareVideo(video);
          loadVideoSources(video);
        }
      });
    }

    cards.forEach(function (card) {
      var video = getVideo(card);
      var muteBtn = card.querySelector('[data-sbv-mute]');

      if (!video) {
        if (muteBtn) muteBtn.style.display = 'none';
        return;
      }

      prepareVideo(video);

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (!sectionInView) {
            activateVideosOnce();
            sectionInView = true;
          }

          var willUnmute = video.muted;
          if (willUnmute) {
            cards.forEach(function (other) {
              var otherVideo = getVideo(other);
              var otherMute = other.querySelector('[data-sbv-mute]');
              if (otherVideo && otherVideo !== video) {
                otherVideo.muted = true;
                if (otherMute) {
                  otherMute.classList.remove('is-unmuted');
                  otherMute.setAttribute('aria-pressed', 'false');
                  otherMute.setAttribute('aria-label', 'Unmute video');
                }
              }
            });
          }

          video.muted = !willUnmute;
          muteBtn.classList.toggle('is-unmuted', !video.muted);
          muteBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');

          if (video.paused) {
            playVideo(video);
          }
        });
      }
    });

    function getCardStep() {
      var card = cards[0];
      if (!card) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.offsetWidth + gap;
    }

    function scrollToIndex(index) {
      if (!cards.length) return;
      var step = getCardStep();
      track.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    function getActiveIndex() {
      var step = getCardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function scrollByCard(direction) {
      if (!cards.length) return;
      var index = getActiveIndex();
      var next = index + direction;
      if (next < 0) next = cards.length - 1;
      if (next >= cards.length) next = 0;
      scrollToIndex(next);
    }

    function stopAutoScroll() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function startAutoScroll() {
      stopAutoScroll();
      if (!sectionInView || reduceMotion || userPausedScroll || cards.length < 2) return;
      autoTimer = setInterval(function () {
        scrollByCard(1);
      }, AUTO_SCROLL_MS);
    }

    function restartAutoScroll() {
      if (userPausedScroll || !sectionInView) return;
      startAutoScroll();
    }

    var scrollPlayTimer = null;
    track.addEventListener(
      'scroll',
      function () {
        if (!sectionInView) return;
        if (scrollPlayTimer) clearTimeout(scrollPlayTimer);
        scrollPlayTimer = setTimeout(playVisibleVideos, 80);
      },
      { passive: true }
    );

    /* Eagerly attach sources so posters/first frames show even before play */
    cards.forEach(function (card) {
      var video = getVideo(card);
      if (video) {
        prepareVideo(video);
        loadVideoSources(video);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sectionInView = entry.isIntersecting;
            if (entry.isIntersecting) {
              activateVideosOnce();
              playVisibleVideos();
              restartAutoScroll();
            } else {
              stopAutoScroll();
              pauseAllVideos();
            }
          });
        },
        /* Lower threshold so tall sections still activate when partially on screen */
        { root: null, rootMargin: '120px 0px 120px 0px', threshold: 0.05 }
      );
      io.observe(root);
    } else {
      sectionInView = true;
      activateVideosOnce();
      playVisibleVideos();
      startAutoScroll();
    }

    /* If already in view on init (common after soft-nav / theme refresh), start now */
    requestAnimationFrame(function () {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (rect.top < vh && rect.bottom > 0) {
        sectionInView = true;
        activateVideosOnce();
        playVisibleVideos();
        restartAutoScroll();
      }
    });

    track.addEventListener('pointerdown', function () {
      stopAutoScroll();
    });
    track.addEventListener('pointerup', function () {
      restartAutoScroll();
    });
    track.addEventListener('mouseenter', function () {
      stopAutoScroll();
    });
    track.addEventListener('mouseleave', function () {
      restartAutoScroll();
    });

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;
    var mq = window.matchMedia('(min-width: 750px)');

    track.addEventListener('pointerdown', function (e) {
      if (!mq.matches) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button, a')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown || !mq.matches) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = scrollLeft - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
      playVisibleVideos();
      restartAutoScroll();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (moved && mq.matches) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoScroll();
        pauseAllVideos();
      } else if (sectionInView) {
        playVisibleVideos();
        userPausedScroll = false;
        startAutoScroll();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-by-video]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      var el = event.target.querySelector('[data-shop-by-video]') || event.target;
      if (el && el.dataset) el.dataset.sbvInit = '';
      initSection(el);
    }
  });
})();
